import { useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Container,
  NumberInput,
  NumberInputField,
  FormControl,
  Flex,
  Heading,
  Text,
} from "@chakra-ui/react";
import "iframe-resizer/js/iframeResizer.contentWindow";
import "./App.css";

// Translations
const translations = {
  pt: {
    weightLabel: "Insira aqui o peso em KG:",
    ingredients: "Ingredientes",
    quantity: "Quantidade",
    measure: "Medida",
  },
  en: {
    weightLabel: "Enter the weight in KG:",
    ingredients: "Ingredients",
    quantity: "Quantity",
    measure: "Measure",
  },
  es: {
    weightLabel: "Ingrese el peso en KG:",
    ingredients: "Ingredientes",
    quantity: "Cantidad",
    measure: "Medida",
  },
};

function App() {
  let params = useParams();
  let [searchParams] = useSearchParams();
  let lang = searchParams.get("lang") || "pt";
  let t = translations[lang] || translations.pt;

  let data = params.str.split("|");
  let ingredients = data[0].split(";");
  let recipe = data[1];
  //let qty = data[2] ? data[2] : 14.5;
  ingredients.forEach(function (element, index) {
    ingredients[index] = element.split(",");
  });
  const [inputValue, setInputValue] = useState();

  return (
    <div>
      <Container maxW="container.lg" padding="0">
        <Heading className="capitalize-first" mb={5}>
          {recipe}
        </Heading>
        <FormControl mb={5}>
          <Flex alignItems="center" gap={3}>
            <Text as="b">{t.weightLabel}</Text>
            <NumberInput
              precision={2}
              step={0.2}
              type="text"
              id="inputField"
              defaultValue={inputValue}
              onChange={(valueString) => setInputValue(valueString)}
              flex={1}
            >
              <NumberInputField />
            </NumberInput>
          </Flex>
        </FormControl>
        <TableContainer>
          <Table variant="striped" size="sm">
            <Thead>
              <Tr>
                <Th>{t.ingredients}</Th>
                <Th isNumeric>{t.quantity}</Th>
                <Th w="7em" textAlign="center">
                  {t.measure}
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {ingredients.map(function (ingredient, i) {
                return (
                  <Tr key={i}>
                    <Td>{ingredient[0]}</Td>
                    <Td isNumeric>
                      {inputValue
                        ? ingredient[2].toLowerCase() === "gramas"
                          ? Math.round(ingredient[1] * inputValue)
                          : (ingredient[1] * inputValue).toFixed(2)
                        : 0}
                    </Td>
                    <Td textAlign="center">
                      {ingredient[2] ? ingredient[2] : ""}
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </TableContainer>
      </Container>
    </div>
  );
}

export default App;
